export const PRIVACY_POLICY_LINK = 'https://bluebolt.pl/privacypolicy.pdf'
export const ICS_FILE_NAME = 'CalendarEvent.ics'
